var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.model
      ? _c(
          "div",
          [
            _c("radio-button-row", {
              key: _vm.radioButtonValueChanged,
              attrs: {
                title: "SummaryReport.Collaboration.Partners.HasPartners",
                required: true
              },
              model: {
                value: _vm.model.hasPartners,
                callback: function($$v) {
                  _vm.$set(_vm.model, "hasPartners", $$v)
                },
                expression: "model.hasPartners"
              }
            }),
            _vm._v(" "),
            _vm.hasPartners && _vm.partners.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.partners, function(partner, index) {
                    return _c(
                      "div",
                      { staticClass: "group-wrapper mb-3" },
                      [
                        _c("div", [
                          _c(
                            "div",
                            { class: "heading-div " + "partner-" + index },
                            [
                              _c("header-control", {
                                attrs: {
                                  title: _vm.$t(
                                    "SummaryReport.Collaboration.Partners.PartnerWithIndex",
                                    null,
                                    [index + 1]
                                  ),
                                  h4: true,
                                  doNotUseResources: true
                                }
                              }),
                              _vm._v(" "),
                              _vm.partners.length > 1 && !_vm.isReadOnly
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "header-row-button btn btn-link btn-contrast float-right d-inline-block",
                                      attrs: {
                                        type: "button",
                                        "aria-label":
                                          _vm.$t(
                                            "SummaryReport.Collaboration.Partners.DeletePartner"
                                          ) +
                                          (index + 1) +
                                          " " +
                                          _vm.$t(
                                            "Accessibility.ConfirmDeletePartner"
                                          )
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deletePartner(partner)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-trash-alt fa-lg"
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("summary-partner-control", {
                          key: _vm.partnerKey + index,
                          attrs: {
                            partner: partner,
                            title: "SummaryReport.Partners.Partner",
                            index: index,
                            allowRegionOption: _vm.allowRegionOption
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasPartners && !_vm.isReadOnly
              ? _c("div", { staticClass: "mt-3" }, [
                  _vm.partners.length < 10
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.create()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SummaryReport.Collaboration.Partners.AddPartner"
                              )
                            )
                          )
                        ]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: {
                            type: "button",
                            disabled: "",
                            "aria-disabled": "true"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SummaryReport.Collaboration.Partners.AddPartner"
                              )
                            )
                          )
                        ]
                      )
                ])
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }